"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencySymbolPosition = void 0;
/**
 * Enum CurrencySymbolPosition is used to define override for currency symbol position formatting.
 */
var CurrencySymbolPosition;
(function (CurrencySymbolPosition) {
    /**
     * This override is default for all locales, the way it is defined in CLDR.
     */
    CurrencySymbolPosition["DEFAULT"] = "default";
    /**
     * A formatted value with this override added will have currency symbol at the beginning
     * in the in-memory sequence (logical sequence) in currency pattern.
     *
     * Visual display position when rendered on the screen will depend on whether the display direction
     * is left to right or right to left.
     *
     * E.g., for left to right locales like English, French, etc:
     *
     * "$1,234.56"
     *
     * E.g., for right to left locales like Arabic, Hebrew, etc:
     *
     * "1,234.56$"
     */
    CurrencySymbolPosition["START"] = "start";
    /**
     * A formatted value with this override added will have currency symbol at the end
     * in the in-memory sequence (logical sequence) in currency pattern.
     *
     * Visual display position when rendered on the screen will depend on whether the display direction
     * is left to right or right to left.
     *
     * E.g., for left to right locales like English, French, etc:
     *
     * "1,234.56$"
     *
     * E.g., for right to left locales like Arabic, Hebrew, etc:
     *
     * "$1,234.56"
     */
    CurrencySymbolPosition["END"] = "end";
})(CurrencySymbolPosition = exports.CurrencySymbolPosition || (exports.CurrencySymbolPosition = {}));
//# sourceMappingURL=currency-symbol-position.enum.js.map